// Escolha do "⏰ Me avise em…" (0.67, texto 05 G2): 15 min, 30 min, 1 h ou Outro (escolher dia e hora).
import { useRef, useState } from 'react';
import { Alert } from 'react-native';
import { fecharPedido, marcarAviso, usePedidoMeAvise, type AlvoAviso } from '../lib/meAvise';
import { ActionSheet } from './ui';
import { PickerModal } from './Pickers';
import { useCores } from './theme';
import { t } from '../lib/i18n';
import { hm, horaTela } from '../lib/date';

export function MeAviseHost() {
  const pedido = usePedidoMeAvise();
  const { accent } = useCores();
  const avancou = useRef(false);
  const [outro, setOutro] = useState<{ alvo: AlvoAviso; etapa: 'dia' | 'hora'; data: Date } | null>(null);
  const marcar = async (alvo: AlvoAviso, quando: Date) => {
    if (quando.getTime() <= Date.now()) return Alert.alert(t('Escolha um horário no futuro.'));
    if (await marcarAviso(alvo, quando)) Alert.alert('⏰ ' + t('Aviso marcado'), t('O celular avisa às {h}.', { h: `${String(quando.getDate()).padStart(2, '0')}/${String(quando.getMonth() + 1).padStart(2, '0')} ${horaTela(hm(quando))}` }));
    else Alert.alert(t('Não foi possível'), t('Os avisos funcionam no app instalado, com as notificações ligadas.'));
  };
  const em = (min: number) => () => { const a = pedido; fecharPedido(); if (a) marcar(a, new Date(Date.now() + min * 60000)); };
  return (<>
    <ActionSheet title={'⏰ ' + t('Me avise em…')} actions={pedido ? [
      { label: t('15 min'), onPress: em(15) },
      { label: t('30 min'), onPress: em(30) },
      { label: t('1 h'), onPress: em(60) },
      { label: t('Outro (escolher a hora)'), onPress: () => { const a = pedido; fecharPedido(); if (a) setOutro({ alvo: a, etapa: 'dia', data: new Date(Date.now() + 3600000) }); } },
    ] : null} onClose={fecharPedido} />
    {outro && <PickerModal mode={outro.etapa === 'dia' ? 'date' : 'time'} cor={accent} value={outro.data} onClose={() => { if (avancou.current) { avancou.current = false; return; } setOutro(null); }}
      onPick={d => {
        if (outro.etapa === 'dia') { const n = new Date(outro.data); n.setFullYear(d.getFullYear(), d.getMonth(), d.getDate()); avancou.current = true; setTimeout(() => { avancou.current = false; }, 400); setOutro({ ...outro, etapa: 'hora', data: n }); return; }
        const n = new Date(outro.data); n.setHours(d.getHours(), d.getMinutes(), 0, 0); setOutro(null); marcar(outro.alvo, n);
      }} />}
  </>);
}
